/** @file Filters a list, returning null when unchanged so callers skip the write (no spurious patches). */

/** `list` without the items `drop` selects, or null when nothing would be dropped. */
export function withoutRemoved<T>(list: readonly T[], drop: (item: T) => boolean): T[] | null {
  const kept = list.filter((item) => !drop(item));
  return kept.length === list.length ? null : kept;
}
